import { useSelector } from "react-redux";
import RechargeView from "./view";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";
import { PAYMENT_TYPE } from "@/redux/ducks/customer";


export default function Recharge() {
  const navigate = useNavigate();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);
  
  const goBack = () => navigate("/");

  const goToCard = () => {
    if (customer?.account?.paymentType === PAYMENT_TYPE.IS_CARD) {
      navigate('/payment/card');
      return;
    }
    navigate('/payment/creditCard');
  }

  const goToPix = () => navigate('/payment/pix');
  
  return (
    <RechargeView
      goBack={goBack}
      goToCard={goToCard}
      goToPix={goToPix}
    />
  );
}
